import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSystemSettings } from '../redux/actions/clients';
import { StoreState } from '../types/state';

const useSystemSettings = (clientId: string) => {
  const clientSystemSettings = useSelector((state: StoreState) => {
    return state.clients.systemSettings[clientId];
  });

  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!clientSystemSettings) {
      setIsLoading(true);
      dispatch(getSystemSettings(clientId));
    } else {
      setIsLoading(false);
    }
  }, [clientId, clientSystemSettings, dispatch]);

  return {
    systemSettings: clientSystemSettings,
    isLoading,
  };
};

export default useSystemSettings;
